import { render } from "./Validator.vue?vue&type=template&id=5c0b12bc"
import script from "./Validator.vue?vue&type=script&lang=js"
export * from "./Validator.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__